import React from 'react';
import { VideoArticleList } from '../VideoArticleList';
import {
  elementAttributesToProps,
  RehydratorFunction,
} from '@tr-digital/react-rehydrate';
import { IVideoArticleList } from '../types';

const rehydrator: RehydratorFunction = async (domNode) => {
  const props: IVideoArticleList = elementAttributesToProps(domNode);

  return Promise.resolve(<VideoArticleList {...props} />);
};

export default rehydrator;
